import Col from '@visa/vds/col';
import Row from '@visa/vds/row';
import Typography from '@visa/vds/typography';
import React, { useEffect, useState } from 'react';
import { applyFeeWaiverToProductFee, findProductToApplyFeeWaiver } from '../FeeWaiver/FeeWaiverLogic';
import VSTSOrderSummaryTable from './VSTSOrderSummaryTable';

const VSTSOrderReview = (props) => {
    
    const [orderSummaryProductsList,setOrderSummaryProductList] = useState([])
    const [totalCost, setTotalCost] = useState(0);
    
    const [feeWaiverApplied, setFeeWaiverApplied] = useState(false);

    const appendProductIntoList = (productInfo) => {
        productInfo.startDate = props.selectedVSTSStartDate
        productInfo.endDate = props.selectedVSTSEndDate

        if (orderSummaryProductsList.find(x=> x.id === productInfo.id) == undefined){
            setTotalCost(totalCost + productInfo.fee);
            setOrderSummaryProductList(orderSummaryProductsList => [...orderSummaryProductsList, productInfo])
        }
    }

    useEffect(() => {
        if(props.order != null){
            appendProductIntoList(props.order)
        }
    }, [props.order]);

    /** Fee Waiver or Fee Discount Logic START */
    const applyFeeWaiver = (selectedFeeWaiver) => {
        const product = findProductToApplyFeeWaiver(orderSummaryProductsList, selectedFeeWaiver);
        const newTotalCost = totalCost + applyFeeWaiverToProductFee(product, selectedFeeWaiver);
        setTotalCost(newTotalCost);
        setFeeWaiverApplied(true);
    }

    useEffect(() => {
        if (props.selectedFeeWaiver && orderSummaryProductsList.length > 0 && !feeWaiverApplied) {
            applyFeeWaiver(props.selectedFeeWaiver);
        }
    }, [orderSummaryProductsList, props.selectedFeeWaiver, feeWaiverApplied])
    /** Fee Waiver or Fee Discount Logic END */

    if(props.selectedProductInfoId == null){
        return (<></>)
    }

    return (
        <>
        <Row className="product-details-row">
            <Col className="product-name-col">
                <Typography tag="h2">Order Summary</Typography>
                    <VSTSOrderSummaryTable 
                        orderSummaryProductsList={orderSummaryProductsList} 
                        total={totalCost}
                        selectedFeeWaiver={props.selectedFeeWaiver}
                    />
            </Col>
        </Row>
        </>
    )
}

export default VSTSOrderReview